import React from "react";
import { withNavigation } from '../Components/helpers/withNavigation';
import Body from "../Components/layout/Body";
import TrainingNavigation from "../Components/layout/TrainingNavigation";
import { Form } from 'reactstrap';
import { InformationPageContent, InformationPageControls } from "../Components/layout/InformationPage";
import '../App.css';
import AudioCapturePopup from '../Components/helpers/AudioCapturePopup';
import {v4 as uuid} from 'uuid';
import { TourProvider } from '@reactour/tour';
import { TourBridge, SkipHiddenTourSteps } from '../utils/TourHelpers';

function InformationStepWithTour(props){
  const steps= [
    {
      selector:'.function-bar',
      content:(
      <>
        <li>Home makes the app go back to selecting trainings on the homepage, where you can choose between trainings you have created to view, edit, or export.</li>
        {!props.supportsFSAccess && (
          <li>Click Download Backup to save a copy of your data (your browser will download a file)</li>
        )}
        <li>Help to show this tour again.</li>
      </>
      ),
    },
    {
      selector: '.instruct-navigation-listgroup',
      content:(
        <>
          <li>This is the navigation sidebar showing the steps in the current training.</li>
          <li>You can select any step to navigate directly to it.</li>
        </>
      ),
    },{
      selector: '.main-form',
      content:(
        <>
          <li>This is the main content area showing the information slide for the current training step.</li>
          <li>You can edit the title and information text, and add media using the Audio Narration button.</li>
          <li>You can also capture an image to illustrate the information slide.</li>
        </>
      ),
    },
    {
      selector: '.instruct-control-container',
      content: (
        <>
          <li>Use the Next Step button to proceed to the next step in the training.</li>
          <li>If this is the final information slide, the button will finish the training and return you to the overview.</li>
        </>
      ),
    }
  ]
  return (
    <div className={'training-container'}>
      <TourProvider 
        steps={steps} 
        showBadge={false}
        padding={10} 
        scrollSmooth 
        className="my-custom-tour" 
        onClickClose={() => {props.updateState({showTour: false});}} 
        onClickMask={() => {props.updateState({showTour: false});}} 
      >
        <SkipHiddenTourSteps/>
        <TourBridge showTour={props.showTour} incognitoBrowser={props.incognitoBrowser} updateState={props.updateState}>
          <InformationStep {...props} />
        </TourBridge>
      </TourProvider>
    </div>
  );
}

class InformationStep extends React.Component {

  constructor(props){
    super(props);
    const saveMessage = {
      icon:'success',
      title:'Progress Saved',
      label: '',
      message: '',
      duration: 3000
    };

    this.state = {
      saveMessage: saveMessage
    }
  }

  onNextClick = () => {
    const curURL = new URL(window.location.href);
    if(this.props.uiInUse === 'UI: Accordion'){
      this.props.navigate({
        pathname: '/main-accordion',
        search: curURL.search
      });    
      return;
    }
    if(this.props.currentStep?.InfoSlideType === 2){
      const currentStep = this.props.currentTraining?.Steps?.find(step => step.Index === 0);
      this.props.updateState(currentStep);
      this.props.navigate({
        pathname: '/perform-training',
        search: curURL.search
      });  
      return;
    }
    var previewStep = this.props.currentTraining?.Steps?.find(step => step.Index === this.props.currentStep.Index + 1);
    if(!previewStep) {
      previewStep = {
          id: uuid(),
          Index: 1,
          Title: 'Preview Checklist',
          Step: 0,
          StepType: 3,
      };
    }
    const currentStep = previewStep;
    this.props.updateState({currentStep, tempMessage: this.state.saveMessage});
    this.props.navigate({
      pathname: '/checklist-step',
      search: curURL.search
    }); 
  }

  handleTitleChange = (event) => {
    var updatedIntroductionStep = this.props.currentStep;
    updatedIntroductionStep.Title = event.target.value;
    this.setState({
      introductionStep: updatedIntroductionStep
    });
    this.props.updateState({currentStep: updatedIntroductionStep});
  };

  handleTextChange = (event) => {
    var updatedIntroductionStep = this.props.currentStep;
    updatedIntroductionStep.Information = event.target.value;
    this.setState({
      introductionStep: updatedIntroductionStep
    });
    this.props.updateState({currentStep: updatedIntroductionStep});
  };

  openMediaCapture = () => {
    const curURL = new URL(window.location.href);
    this.props.navigate({
      pathname: '/camera',
      search: curURL.search
    });
  };

  onNavigationClick = (selectedStep) => {
    if(this.props.uiInUse === 'UI: Accordion'){
      return;
    }
    const currentStep = selectedStep;
    this.props.updateState({currentStep, tempMessage: this.state.saveMessage});
    if(currentStep.StepType === 3){
      const curURL = new URL(window.location.href);
      this.props.navigate({
        pathname: '/checklist-step',
        search: curURL.search
      });
    }
  }

  render() {
    console.log("rendering InformationStep, with props: ", this.props, " state: ", this.state);
    if(!this.props.currentTraining){
      return (<div><p>No training selected.</p></div>);
    }
    const disableEditing = this.props.uiInUse === 'UI: Accordion';
    const nextStepText = disableEditing ? 'Return to Overview' : (this.props.currentStep?.InfoSlideType === 2 ? 'Finish' : 'Next Step');
    const audioButtonText = this.props.currentStep?.AudioFilepath ? 'Edit Step Audio Narration' : 'Add Step Audio Narration';
    return (
      <Body
        contentComponent={
          <Form id='main-form' className='main-form'>
            <div               
              id='content-container' 
              className='content-container justify-content-center align-items-center'>
                  <InformationPageContent 
                    slideTitle={this.props.currentStep?.Title}
                    information={this.props.currentStep?.Information}
                    contentImage={this.props.currentStep?.ContentImagePath}
                    handleTitleChange={this.handleTitleChange}
                    handleTextChange={this.handleTextChange}
                    openMediaCapture={this.openMediaCapture}
                    getMediaById={this.props.getMediaById}
                    editing={true}
                    disableEditing={disableEditing}
                  />
            </div>
          </Form>
        }
        sidebarComponent={
          <TrainingNavigation
            steps={this.props.currentTraining?.Steps}
            currentStep={this.props.currentStep?.Index}
            handleItemClick={this.onNavigationClick}
          />
        }
        controlsComponent={
          <InformationPageControls 
            NextStepText={nextStepText}
            handleNextClick={this.onNextClick}
            currentTraining={this.props.currentTraining}
            currentStep={this.props.currentStep}
            updateState={this.props.updateState}
            audioButtonText={audioButtonText}
            disableEditing={disableEditing}
          />
        }
      />
    );
  }
}
export default withNavigation(InformationStepWithTour);